import { ActionsFactory } from '../factories/actions.factory';
import { ActionTypesFactory } from '../factories/actionTypes.factory';

export const UsersActions = new ActionsFactory('users', ActionTypesFactory('USERS'));
